<template>
    <div class="forecast">
        <div class="tit">
            <img src="@/assets/common/titLogo.png"
                 alt="" />
            <span>
                {{
					lotteryType == 0 ? '双色球':
					lotteryType == 1 ? '大乐透':
					lotteryType == 2 ? '福彩3D':
					lotteryType == 3 ? '排列三':''
				}}指标学霸最新预测
            </span>
        </div>
        <div class="cont"
             style="position:relative"
             v-loading="listLoading">
            <!-- 加载失败 -->
            <div v-if="loadError" class="error-container">
                <div class="error-icon">!</div>
                <div class="error-text">加载失败</div>
                <div class="error-retry" @click="getList">点击重试</div>
            </div>

            <!-- 数据列表 -->
            <template v-else>
                <div v-for="(item, index) in list"
                     :key="index" style="font-size:14px;">
                    <span @click="view_history2(item,(
								lotteryType == 0 ? 'ssq':
								lotteryType == 1 ? 'dlt':
								lotteryType == 2 ? 'fcse':
								lotteryType == 3 ? 'pls':''
							))" style="cursor: pointer;color:#4084b4">{{item.nickName}}</span>
                    <span style="font-size:12px">
                    	<!-- <span>{{item.realBetNumber}}注</span> -->
						<span v-if="item.realBetNumber == '0'"></span>
	                    <span v-else>{{item.realBetNumber}}注</span>
						<!-- {{item.preIndexTypeLabel}} -->
	                    <span v-if="item.preIndexTypeLabel=='杀6蓝'||item.preIndexTypeLabel=='杀4蓝'
	                    ||item.preIndexTypeLabel=='围4蓝'||item.preIndexTypeLabel=='围3后'">
	                        {{item.preIndexTypeLabel}}</span>
                    </span>
                    <span>{{item.coin}}缩币</span>
                    <span>{{item.achievement}}</span>
                </div>

                <!-- 暂无内容 -->
    			<div v-if="!listLoading && (!list || list.length === 0)" class="empty-tip">暂无内容</div>
            </template>
        </div>
    </div>
</template>

<script>
import { queryPreRankingList } from "@/api/home/index"
export default {
    props: ["lotteryType"],
    data () {
        return {
            list: [],
			listLoading: false,
			loadError: false,    // 【P0 修复】错误状态
            db: {}
        };
    },
    mounted () {
        // 【性能优化】错峰加载：随机延迟 0~600ms，避免首页多个排行榜同时请求
        const delay = 300 + Math.floor(Math.random() * 300)
        setTimeout(() => {
            this.getList()
        }, delay)
    },
    methods: {
        view_history2 (item, preType) {
		    this.$router.push({
		    	path: '/dating_viewHistory',
		    	query:{
		    		shrinkId: item.shrinkId || item.createUser,
		    		number: item.number,
		    		userName: item.nickName,
		    		preType,
		    	}
		    })
        },
		// 查看历史记录
		view_history (item, preIndexType, preType, backNumber) {
			
			this.$router.addRoute({
				path: '/dating_viewHistory',
				name: 'dating_viewHistory',
				component: () => import('@/views/homePage/menu/suoshuidan_dating/components/viewHistory.vue')
			})

			const routeExists = this.$router.options.routes.some(route => route.name === 'dating_viewHistory');
			let trim = setInterval(() => {
				if (!routeExists) {
					clearInterval(trim)
					this.$router.push({
						path: '/dating_viewHistory',
						query: {
							item,
							preIndexType:item.preIndexType,
							preType:this.lotteryType,
							backNumber:item.number
						}
					})
				}

			}, 100)
		},
		// 【P0 修复】增加错误处理、加载状态
        getList () {
			this.listLoading = true
			this.loadError = false
            queryPreRankingList({
                preType: this.lotteryType,
            }).then(async res => {
				// 业务成功才处理
				if (res && (res.code === 200 || res.code === undefined)) {
	                let list = res.data && await this.getIndexType(this.lotteryType, res.data)
	                this.list = list || []
				} else {
					this.list = []
					this.loadError = true
				}
            }).catch(err => {
				// 【P0 修复】捕获网络/超时/HTTP 错误
				console.error('预测列表加载失败', err)
				this.list = []
				this.loadError = true
				// 全局错误提示已在 http.js 中统一弹出
			}).finally(() => {
				this.listLoading = false
			})
        },

        async getIndexType (lotteryType, lotteryDb) {

            let resDb = [];

            let params = [
                'pre_double_index_type',   	    //双色球
                'pre_lottery_index_type',	    //大乐透
                'pre_fucai3d_index_type',	    //福彩3D
                'pre_pailiesan_index_type',	    //排列三
            ]

            let res = await this.$utils.getDictionary(params[lotteryType])

            lotteryDb && lotteryDb.forEach(item => {
                let handleDb = {
                    ...item,
                    preIndexTypeLabel: res.data.filter(ite => ite.dictValue == item.preIndexType)[0]?.dictLabel || ''
                }
                resDb.push(handleDb)
            });

            return JSON.parse(JSON.stringify(resDb))
        },

    },
};
</script>

<style lang="scss" scoped>
.forecast {
    height: calc(100% - 36px);
    .tit {
        font-weight: bold;
        padding: 10px;
        padding-top: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.07);
        display: flex;
        align-items: center;
        img {
            width: 20px;
            margin-right: 10px;
        }
    }
    .cont {
        height: 100%;
		border: 1px solid #8fb3da;
        div {
            border-bottom: 1px solid rgba(0, 0, 0, 0.07);
			padding: 0 10px ;
            display: flex;
            justify-content: space-between;
			&:last-child{
				border-bottom: 0;
			}
            span {
                padding: 16.5px 0;
                flex: 1;
                text-align: center;
                white-space: nowrap;
            }
        }

		// 【P0 修复】错误状态
		.error-container {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			display: flex;
			flex-direction: column;
			align-items: center;
			color: #999;

			.error-icon {
				width: 36px;
				height: 36px;
				line-height: 36px;
				border-radius: 50%;
				background-color: #fef0f0;
				color: #f56c6c;
				font-size: 18px;
				font-weight: bold;
				margin-bottom: 8px;
			}
			.error-text {
				font-size: 13px;
				margin-bottom: 8px;
			}
			.error-retry {
				font-size: 12px;
				color: #409eff;
				cursor: pointer;
				&:hover {
					text-decoration: underline;
				}
			}
		}

		// 暂无内容样式
		.empty-tip {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			font-size: 14px;
			border-bottom: 0 !important;
			color: rgba(0, 0, 0, 0.3);
			padding: 0 !important;
			display: block !important;
		}
    }
}
</style>
